import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTeaAndCoffee = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 20,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17v1H0v-1h20ZM15.586 0a1 1 0 0 1 .79 1.613l-.083.094L15 3v12H5l-.001-2H3v-1h1.999v-1H3a1 1 0 0 1-.993-.883L2 10V3a1 1 0 0 1 .883-.993L3 2h1.999L5 0h10.586Zm0 1H6v13h8V2.586L15.586 1ZM4.999 3H3v7h1.999V3Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgTeaAndCoffee;